


















































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { companyServer, institutionServer, patrolManagementServe, professionServer, schedulePlan } from '@/api/installServer';
import { arrayToTree } from '@/util/array';

@Component({
  components: {},
})
export default class PatrolEdit extends Vue {
  @Prop(Number) editOrganFlag!: number; // 控制编辑还是新增机构
  @Prop(String) rowId!: string; // 父组件传递过来的 rowId
  @Prop(String) type!: any; // 父组件传递过来一行的 type 类型

  private editTableMark: any = {};
  private saveDisabled: any = false; // 按钮限制重复点击
  private enterpriseData: any = [];
  private planList: any = [];
  private lineList: any = [];
  private departList: any = [];
  private postList: any = [];
  private patrolDetail: any = {
    id: '',
    name: '',
    describe: '',
    scheduleId: '',
    weekType: '1',
    monthType: '1',
    weekExcludeDay: '0',
    endMonthPadded: true,
    isMerge: true,
    scheduleOrderInfo: [],
    startMonthValue: 1,
    companyId: '',
    companyName: '',
  };
  private patrolChecked: any = '';
  private loading: any = false;
  private patrolRules: any = {
    name: [{ required: true, message: '请输入任务名称', trigger: 'blur' }],
    scheduleId: [{ required: true, message: '请选择排班方案', trigger: 'blur' }],
  };

  async created() {
    this.getEnterpriseDataList();
    this.getPlanListData({});
    this.getLineList({ paging: false });
    this.getDepartListData({});
    this.getPostListData({});
    if (this.type === 'edit') {
      await this.getPatrolData(this.rowId);
    } else {
      this.patrolDetail = {
        id: '',
        name: '',
        describe: '',
        scheduleId: '',
        weekType: '1',
        monthType: '1',
        weekExcludeDay: '0',
        endMonthPadded: true,
        isMerge: true,
        scheduleOrderInfo: [],
        startMonthValue: 1,
        companyId: '',
        companyName: '',
      };
    }
  }

  editTableMarkChange(index: any) {
    Vue.set(this.editTableMark, index.$index, true);
  }
  /**
   * 【接口】获取企业列表
   */
  private getEnterpriseDataList() {
    companyServer
      .getCompanySelectList({
        companyPlaceType: 'COMPANY',
      })
      .then((res: any) => {
        this.enterpriseData = res.data;
      });
  }
  companyChange(e: any) {
    this.patrolDetail.companyName = '';
    if (e) {
      this.patrolDetail.companyName = this.enterpriseData.find((item: any) => item.id === e).companyName;
    }
  }

  private mounted() {}

  /**
   *【表单】选择排班方案触发函数
   * @Params
   * @return
   **/
  async changePlan(data: any) {
    if (data !== '') {
      const res: any = await schedulePlan.getOrder(this.patrolDetail.scheduleId);
      if (res.code === '200') {
        this.patrolDetail.scheduleOrderInfo = res.data;
      }
    } else {
      this.patrolDetail.scheduleOrderInfo = [];
    }
  }

  /**
   * 【接口】获取巡检线路列表
   */
  async getLineList(opts: object) {
    try {
      const res: any = await patrolManagementServe.getPatrolLineAllData(opts);
      if (res.code === '200') {
        this.lineList = res.data;
      } else {
        this.$message.warning('网络异常，请稍后重试。');
        throw new Error();
      }
    } catch (e) {
      throw new Error();
    }
  }

  /**
   *【接口】获取排班方案列表
   * @Params
   * @return
   **/
  async getPlanListData(opts: object) {
    const res: any = await schedulePlan.getAllList(opts);
    if (res.code === '200') {
      this.planList = res.data;
    }
  }

  /**
   * @desc 获取可选部门接口
   */
  getDepartListData(opts: object) {
    institutionServer
      .getDeptAndSubDeptList(opts)
      .then((res: any) => {
        if (res.code === '200') {
          this.departList = arrayToTree(res.data);
        }
      })
      .catch((error: any) => {
        this.$message.error('数据请求失败，请稍后重试！');
      });
  }

  /**
   *【接口】获取岗位列表
   * @Params
   * @return
   **/
  getPostListData(opts: object) {
    professionServer
      .getPageDataAll(opts)
      .then((res: any) => {
        if (res.code === '200') {
          this.postList = res.data;
        }
      })
      .catch((error: any) => {
        this.$message.error('数据请求失败，请稍后重试！');
      });
  }

  /**
   *【接口】获取巡检方案详情
   * @Params
   * @return
   **/
  async getPatrolData(id: string) {
    this.loading = true;
    const res: any = await patrolManagementServe.detailPatrolSchedule(id);
    if (res.code === '200') {
      this.patrolDetail = res.data;
      this.loading = false;
    }
  }

  /**
   *【接口】巡检方案添加
   * @Params
   * @return
   **/
  async addPatrolData() {
    const tempOrderInfo: any = [];
    this.patrolDetail.scheduleOrderInfo.forEach((item: any) => {
      const tempStaffInfo: any = [];
      item.staffInfo.forEach((ctx: any) => {
        tempStaffInfo.push({
          id: ctx.id,
          staffId: ctx.staffId,
          postId: ctx.postId,
          deptId: ctx.deptId,
          lineId: ctx.lineId,
        });
      });
      tempOrderInfo.push({
        orderId: item.orderId,
        staffInfo: tempStaffInfo,
      });
    });
    try {
      const res: any = await patrolManagementServe.addPatrolSchedule({
        name: this.patrolDetail.name,
        describe: this.patrolDetail.describe,
        scheduleId: this.patrolDetail.scheduleId,
        weekType: this.patrolDetail.weekType,
        monthType: this.patrolDetail.monthType,
        weekExcludeDay: this.patrolDetail.weekExcludeDay,
        endMonthPadded: this.patrolDetail.endMonthPadded,
        isMerge: this.patrolDetail.isMerge,
        scheduleOrderInfo: tempOrderInfo,
        startMonthValue: this.patrolDetail.startMonthValue,
        companyId: this.patrolDetail.companyId,
        companyName: this.patrolDetail.companyName,
      });
      if (res.code === '200') {
        this.$message.success('您成功保存了记录。');
        this.$emit('update:show', true); // 返回主页
        this.saveDisabled = false;
      } else {
        this.$message.warning('保存失败');
        this.saveDisabled = false;
        throw new Error();
      }
    } catch (e) {
      throw new Error();
    }
  }

  /**
   *【接口】巡检方案修改
   * @Params
   * @return
   **/
  async editPatrolData(id: string) {
    const tempOrderInfo: any = [];
    this.patrolDetail.scheduleOrderInfo.forEach((item: any) => {
      const tempStaffInfo: any = [];
      item.staffInfo.forEach((ctx: any) => {
        tempStaffInfo.push({
          id: ctx.id,
          staffId: ctx.staffId,
          postId: ctx.postId,
          deptId: ctx.deptId,
          lineId: ctx.lineId,
        });
      });
      tempOrderInfo.push({
        orderId: item.orderId,
        staffInfo: tempStaffInfo,
      });
    });
    const res: any = await patrolManagementServe.editPatrolSchedule(id, {
      name: this.patrolDetail.name,
      describe: this.patrolDetail.describe,
      scheduleId: this.patrolDetail.scheduleId,
      weekType: this.patrolDetail.weekType,
      monthType: this.patrolDetail.monthType,
      weekExcludeDay: this.patrolDetail.weekExcludeDay,
      endMonthPadded: this.patrolDetail.endMonthPadded,
      isMerge: this.patrolDetail.isMerge,
      scheduleOrderInfo: tempOrderInfo,
      startMonthValue: this.patrolDetail.startMonthValue,
      companyId: this.patrolDetail.companyId,
      companyName: this.patrolDetail.companyName,
    });
    if (res.code === '200') {
      this.$message.success('您成功保存了记录。');
      this.$emit('update:show', true); // 返回主页
      this.saveDisabled = false;
    } else {
      this.$message.warning('保存失败');
      this.saveDisabled = false;
      throw new Error();
    }
  }

  /**
   *【按钮】提交按钮点击
   * @Params
   * @return
   **/
  handleSubmitBtnClick() {
    this.saveDisabled = true;
    const formComponent: any = this.$refs['patrolDetail'];
    formComponent.validate((valid: any) => {
      if (!valid) return;
      switch (this.type) {
        case 'add':
          this.addPatrolData();
          break;
        case 'edit':
          this.editPatrolData(this.patrolDetail.id);
          break;
      }
    });
  }

  /**
   * @desc 返回上一个页面
   * @param1 暂无
   * @returns 暂无
   */
  close() {
    const formComponent: any = this.$refs['patrolDetail'];
    formComponent.clearValidate();
    this.$emit('update:show', true); // 返回主页
  }
}
